<div class="form-group">
  <div class="input-group">
    <div class="d-block w-100">

      <h3 (click)="searchComponentClick()"
        [attr.aria-expanded]="!isSearchCollapsed"
        aria-controls="searchFields"
        class="dropdown-toggle">
        <i class="fas fa-filter fa-lg fa-fw icon-spacing"></i> Filter by: </h3>
      </div>
      <div class="d-block w-100">
        <ul [ngbCollapse]="isSearchCollapsed" class="collapse list-unstyled" id="searchFields">
          <li>
            <ng-content select="[filters]"></ng-content>
          </li>
        </ul>
      </div>
      <ng-content select="[export]"></ng-content>
    </div>
  </div>

  <ng-content select="[grid]"></ng-content>

  <div class="form-group">
    <nav>
      <ul class="pagination justify-content-center search-orange">
        <li [ngClass]="{ 'disabled': results == null || results?.first }" class="page-item">
          <a (click)="updatePage(0)" class="page-link" tabindex="-1">First</a>
        </li>

        <li [ngClass]="{ 'disabled': results == null || results?.first }" class="page-item">
          <a (click)="updatePage(currentPage-1)" class="page-link" tabindex="-1">Previous</a>
        </li>
        @for (page of pager; track page) {
          <li [ngClass]="{'active':currentPage == page}" class="page-item">
            <a (click)="updatePage(page)" class="page-link">{{ page + 1 }}</a>
          </li>
        }
        <li [ngClass]="{ 'disabled': results == null || results?.last }" class="page-item">
          <a (click)="updatePage(currentPage+1)" class="page-link" tabindex="-1">Next</a>
        </li>
        <li [ngClass]="{ 'disabled': results == null || results?.last }" class="page-item">
          <a (click)="updatePage(results?.totalPages-1)" class="page-link" tabindex="-1">Last</a>
        </li>
      </ul>
    </nav>
  </div>

  <ngx-ui-loader></ngx-ui-loader>